import { IonCard } from "@ionic/react";
import { ComponentProps } from "react";

import styles from "@components/cards/SquareCard.module.css";
import { Colors } from "@utils/colorUtils";

type Props = Omit<ComponentProps<typeof IonCard>, "button" | "color" | "href" | "onClick" | "routerLink"> & {
  color?: Colors;
};

const SquareCard = ({ children, className, color = "white", ...cardProps }: Props) => {
  const wrapperStyles = [styles.squareCard, "flex", "items-center", "justify-center", "flex-column"];

  if (className) wrapperStyles.push(className);

  return (
    <IonCard {...cardProps} className={wrapperStyles.join(" ")} color={color}>
      {children}
    </IonCard>
  );
};

export default SquareCard;
